<template>
  <LayoutTelas
    id="tela__usuarios"
    :titulo="this.$route.meta.titulo"
    :isLoading="isLoading">

    <UsuariosCadastroForm
      ref="formUsuario"
      :dados="dadosUsuario"
      @resetarSenha="resetarSenha"
      @gravar="gravar" />

  </LayoutTelas>
</template>

<script>
import UsuariosCadastroForm from './UsuariosCadastroForm.vue'
import UsuarioService from '../../../services/usuarios.service'
import GeradorMensagens from '@/mixins/GeradorMensagens'

export default {
  name: 'UsuariosCadastro',
  components: {
    UsuariosCadastroForm,
  },
  mixins: [GeradorMensagens],
  data() {
    return {
      dadosUsuario: null,
      isLoading: false,
    }
  },
  beforeMount() {
    this.carregar()
  },
  methods: {
    async gravar(dados) {
      this.mostrarLoader()
      try {
        const retorno = await this.retornaMetodoGravacao(dados)
        this.tratarRespostaMsg(retorno)

        this.$refs.formUsuario.sair()
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoader(false)
      }
    },
    retornaMetodoGravacao(dados) {
      return dados._id
        ? UsuarioService.atualizar(dados)
        : UsuarioService.gravar(dados)
    },
    async carregar() {
      if (this.$route.params.id) {
        this.mostrarLoader()
        try {
          this.dadosUsuario = await UsuarioService.retornaPorId(this.$route.params.id)
        } catch (error) {
          this.tratarRespostaMsg(error)
          this.$router.push({ name: 'rota-usuarios' })
        } finally {
          this.mostrarLoader(false)
        }
      }
    },
    mostrarLoader(mostrar = true) {
      this.isLoading = mostrar
    },
    async resetarSenha(dados) {
      this.mostrarLoader()
      try {
        const retorno = await UsuarioService.resetarSenha(dados)
        this.tratarRespostaMsg(retorno)
        this.$router.push({ name: 'rota-usuarios' })
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoader(false)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";

#tela__usuarios {
  display: flex;
  flex-direction: column;
  max-width: 100%;

  @media (min-width: $medium-size) {
    min-width: $small-size;
  }
}

</style>
